import { actions } from './actions'
import { mutations } from './mutations'

/* TODO: move cart on the correct store, cart that is not yet available */
export const frameGenius = {
  namespaced: true,
  state: {
    isFrameAdvisorOpen: false,
    isSizeAdvisorOpen: false,
    analysisResults: undefined,
    areScriptsLoaded: false,
    isFloatingButtonVisible: false,
  },
  getters: {
    isFrameAdvisorOpen: (state) => state.isFrameAdvisorOpen,
    isSizeAdvisorOpen: (state) => state.isSizeAdvisorOpen,
    analysisResults: (state) => state.analysisResults,
    areScriptsLoaded: (state) => state.areScriptsLoaded,
    isFloatingButtonVisible: (state) => state.isFloatingButtonVisible,
  },
  mutations,
  actions,
}
